module.exports = __webpack_public_path__ + "img/businessName.91941edc.png";